import React from "react";
import axios from "axios";
import constant from "../../constant";
import SearchBox from "./SearchBox";

import "./style.scss";

export default class SearchComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cursor: 0,
      search_value: "",
      res_value: "",
      search_list: null,
      isLoading: true
    };
  }

  componentDidMount() {
    let { searched_text } = this.props;
    this.typeWrite();

    if (searched_text && searched_text !== "") {
      this.setState({
        search_value: searched_text,
        isLoading: false
      });
    }
  }

  // Auto Filling Text
  typeWrite = () => {
    let TxtType = function(el, toRotate, period) {
      this.toRotate = toRotate;
      this.el = el;
      this.loopNum = 0;
      this.period = parseInt(period, 15) || 1800;
      this.txt = "";
      this.tick();
      this.isDeleting = false;
    };

    TxtType.prototype.tick = function() {
      let i = this.loopNum % this.toRotate.length;
      let fullTxt = this.toRotate[i];

      if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
      } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
      }

      this.el.innerHTML = "<span>" + this.txt + "</span>";

      let _this = this;
      let delta = 200 - Math.random() * 100;

      if (this.isDeleting) {
        delta /= 2;
      }

      if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
      } else if (this.isDeleting && this.txt === "") {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
      }

      setTimeout(function() {
        _this.tick();
      }, delta);
    };

    let txtJSON =
      '[ "Los Angeles", "Chiang Mai", "Aarhus", "New York", "Copenhagen", "Sydney", "Tokyo", "Cebu",  "Stockholm", "Barcelona", "Madrid", "Chennai", "Paris" ]';

    let txtDuration = 1500;
    let elements = document.getElementsByClassName("typewrite");

    for (var i = 0; i < elements.length; i++) {
      let toRotate = txtJSON;
      let period = txtDuration;

      if (toRotate) {
        new TxtType(elements[i], JSON.parse(toRotate), period);
      }
    }
  };

  handleSearch = e => {
    e.preventDefault();
    let _this = this;
    let val = e.target.value.trim();

    _this.setState(
      {
        search_value: val,
        isLoading: true
      },
      () => {
        if (val !== "") {
          axios
            .get(`${constant.phpHost}action/search.php`, {
              params: {
                todo: "get_searched_list",
                search_value: val
              }
            })
            .then(function(res) {
              _this.setState(
                {
                  res_value: val
                },
                () => {
                  if (_this.state.res_value === _this.state.search_value) {
                    _this.setState({
                      cursor: 0,
                      search_list: res.data,
                      isLoading: false
                    });
                  }
                }
              );
            });
        } else {
          _this.setState({
            cursor: 0,
            search_list: null,
            isLoading: false
          });
        }
      }
    );
  };

  handleUrl = (url, text, text_url, city_id, country_id) => {
    let formData = new FormData();
    formData.append("todo", "insert_searched_text");
    formData.append("text", text);
    formData.append("text_url", text_url);
    formData.append("city_id", city_id);
    formData.append("country_id", country_id);

    axios.post(`${constant.phpHost}action/search.php`, formData).then(() => {
      window.location = url;
    });
  };

  scrollToSearchList = index => {
    const scrollItem = document.querySelector(
      `.input-box [scrollindex="${index}"]`
    );
    if (scrollItem) {
      const scrollWrapper = document.querySelector(
        `.input-box [scrollwrapper="scrollwrapper"]`
      );

      const item = scrollItem.offsetTop;
      const wrapper = scrollWrapper.offsetTop;
      scrollWrapper.scrollTo(0, item - wrapper);
    }
  };

  handleKeyDown = e => {
    const { cursor, search_list } = this.state;
    let exactCursor = 0;

    if (e.keyCode === 38 && cursor > 0) {
      exactCursor = -1;
    } else if (e.keyCode === 40 && cursor < search_list.length - 1) {
      exactCursor = 1;
    }

    this.setState(
      prevState => ({
        cursor: prevState.cursor + exactCursor
      }),
      this.scrollToSearchList(this.state.cursor)
    );
  };

  handleKeyPress = e => {
    var code = e.keyCode || e.which;

    if (code === 13) {
      e.preventDefault();
      document.querySelectorAll(".searched-list ul li.active")[0].click();
    }
  };

  render() {
    let { search_value, search_list, cursor, isLoading } = this.state;

    return this.props.pathname === "/" ? (
      <section id="search-home">
        <div className="left">
          <h1 className="title">
            Find your workspace in <label className="typewrite" />
          </h1>
          <SearchBox
            val={search_value}
            handleSearch={this.handleSearch}
            search_list={search_list}
            handleKeyDown={this.handleKeyDown}
            handleKeyPress={this.handleKeyPress}
            cursor={cursor}
            url={this.handleUrl}
            icon={this.icon}
            isHeader={false}
            isLoading={isLoading}
          />
          <div className="space_count">
            <p>
              <b>10,000+</b> Bookings done | <b> 211000+</b> Spaces Listed
            </p>
          </div>
        </div>
        <div className="right" />
      </section>
    ) : (
      <SearchBox
        val={search_value}
        handleSearch={this.handleSearch}
        search_list={search_list}
        handleKeyDown={this.handleKeyDown}
        handleKeyPress={this.handleKeyPress}
        cursor={cursor}
        url={this.handleUrl}
        icon={this.icon}
        isHeader={true}
        isLoading={isLoading}
      />
    );
  }
}
